import { types } from "../../types/types";
import { fetchConToken } from "../../helpers/fetch";
import { startAlerta } from "../ui/alertas";
///import { spinner, spinnerClose } from '../helpers/spinners';
import { startSpinner, finishSpinner } from "../ui/spinner";
import { handleErrorApi } from "../../helpers/randoms";
import { armarParametros } from "../../helpers/parametros";
import { TIPO_TURNO } from '../../utils/constants';
import moment from "moment";

export const agendaTraerStart = () => ({ type: types.agendaTraerStart });
export const agendaLimpiar = () => ({ type: types.agendaLimpiar });
export const agendaLimpiarItems = () => ({ type: types.agendaLimpiarItems });
export const agendaLimpiarDisponibles = () => ({
  type: types.agendaLimpiarDisponibles,
});
export const agendaLimpiarTurnoSeleccionado = () => ({
  type: types.agendaLimpiarSeleccionado,
});
export const agendaTraerError = (error) => ({
  type: types.agendaTraerError,
  payload: error,
});
export const agendaSeleccionarTurno = (payload) => ({
  type: types.agendaTurnosSeleccionarSuccess,
  payload: payload,
});
export const agendaCancelarTurnoSuccess = (payload) => ({
  type: types.agendaCancelarTurnoSuccess,
  payload: payload,
});
export const agendaDiasTraerSuccess = (payload) => ({
  type: types.agendaDiasTraerSuccess,
  payload: payload,
});
export const agendaDiasSobreturnosTraerSuccess = (payload) => ({
  type: types.agendaDiasSobreturnosTraerSuccess,
  payload: payload,
});
export const agendaHorariosTraerSuccess = (payload) => ({
  type: types.agendaHorariosTraerSuccess,
  payload: payload,
});
export const agendaTurnosDisponiblesTraerSuccess = (payload) => ({
  type: types.agendaTurnosDisponiblesTraerSuccess,
  payload: payload,
});
export const agendaTurnosSuccess = (payload) => ({
  type: types.agendaTurnosSuccess,
  payload: payload,
});
export const agendaContadoresSuccess = (payload) => ({
  type: types.agendaContadoresSuccess,
  payload: payload,
});
export const agendaTurnoModificarAsistenciaSuccess = (payload) => ({
  type: types.agendaTurnoModificarAsistenciaSuccess,
  payload: payload,
});

export const TurnosTomadosPorFechaLimpiar = () => ({ 
  type: types.agendaTurnosLimpiar });

export const fetchDiasAgenda = (
  idEspecialidad,
  idCentroMedico,
  idProfesional,
  presencial,
  virtual
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      dispatch(agendaTraerStart());
      const parametros = armarParametros(
        idEspecialidad,
        idCentroMedico,
        idProfesional,
        presencial,
        virtual,
        null,
        null,
        null,
        null,
        null,
        true
      );
      const response = await fetchConToken(`Agenda/traerDias?${parametros}`);
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        const lista = await response.json();
        if (response.status !== 200) throw lista.errores;
        dispatch(agendaDiasTraerSuccess(lista));
        if (lista.length === 0)
          dispatch(
            startAlerta(
              "No se encontraron turnos con los parámetros seleccionados",
              "warning",
              `¡Consultan de Turnos!`
            )
          );
      }
      dispatch(finishSpinner());
    } catch (err) {
      dispatch(finishSpinner());
      dispatch(startAlerta(err, "warning", `¡Error!`));
    }
  };
};

export const fetchHorasAgenda = (
  idEspecialidad,
  idCentroMedico,
  presencial,
  virtual,
  fecha
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      dispatch(agendaTraerStart());
      const parametros = armarParametros(
        idEspecialidad,
        idCentroMedico,
        null,
        presencial,
        virtual,
        fecha,
        null,
        null,
        null,
        null,
        true,
        null,
        null,
        null,
        null,
        true
      );
      const response = await fetchConToken(`Agenda/traerHoras?${parametros}`);
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        const lista = await response.json();
        if (response.status !== 200) throw lista.errores;
        dispatch(agendaHorariosTraerSuccess(lista));
      }
      dispatch(finishSpinner());
    } catch (err) {
      dispatch(finishSpinner());
      dispatch(startAlerta(err, "warning", `¡Error!`));
    }
  };
};

export const fetchTurnosDisponibles = (
  idEspecialidad,
  idCentroMedico,
  idProfesional,
  presencial,
  virtual,
  fecha,
  hora
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      dispatch(agendaTraerStart());
      const parametros = armarParametros(
        idEspecialidad,
        idCentroMedico,
        idProfesional,
        presencial,
        virtual,
        fecha,
        hora,
        null,
        null,
        null,
        true,
        null,
        null,
        null,
        null,
        true
      );
      const response = await fetchConToken(
        `Agenda/traerDisponibles?${parametros}`
      );
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        const lista = await response.json();
        if (response.status !== 200) throw lista.errores;
        dispatch(agendaTurnosDisponiblesTraerSuccess(lista));
      }
      dispatch(finishSpinner());
    } catch (err) {
      dispatch(finishSpinner());
      dispatch(startAlerta(err, "warning", `¡Error!`));
    }
  };
};

export const fetchPrimerTurnoDisponible = (
  idEspecialidad,
  idCentroMedico,
  idProfesional,
  presencial,
  virtual
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      dispatch(agendaTraerStart());
      const parametros = armarParametros(
        idEspecialidad,
        idCentroMedico,
        idProfesional,
        presencial,
        virtual,
        null,
        null,
        null,
        true,
        null,
        null,
        null,
        null,
        null,
        null,
        true
      );
      const response = await fetchConToken(
        `Agenda/traerPrimeroDisponible?${parametros}`
      );
      if (response.status === 204)
        dispatch(
          startAlerta(
            "No se encontraron turnos con los parámetros seleccionados",
            "warning",
            `¡Consulta de Turnos!`
          )
        );
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        const turno = await response.json();
        if (!response.ok) throw turno.errores;
        dispatch(agendaSeleccionarTurno(turno));
      }
      dispatch(finishSpinner());
    } catch (err) {
      dispatch(finishSpinner());
      dispatch(startAlerta(err, "warning", `¡Error!`));
    }
  };
};

export const fetchDiasSobreTurnosAgenda = (
  idEspecialidad,
  idCentroMedico,
  idProfesional,
  presencial,
  virtual
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      dispatch(agendaTraerStart());
      const parametros = armarParametros(
        idEspecialidad,
        idCentroMedico,
        idProfesional,
        presencial,
        virtual
      );
      const response = await fetchConToken(
        `Agenda/traerDiasParaSobreturnos?${parametros}`
      );
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        const lista = await response.json();
        if (response.status !== 200) throw lista.errores;
        dispatch(agendaDiasSobreturnosTraerSuccess(lista));
        if (lista.length === 0)
          dispatch(
            startAlerta(
              "No se encontraron turnos con los parámetros seleccionados",
              "warning",
              `¡Consulta de Turnos!`
            )
          );
      }
      dispatch(finishSpinner());
    } catch (err) {
      dispatch(finishSpinner());
      dispatch(startAlerta(err, "warning", `¡Error!`));
    }
  };
};

export const fetchTurnosPorAfiliado = (idAfiliado, nroDocumento, idObraSocial, tipoConsulta = null) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      dispatch(agendaTraerStart());
      const parametros = tipoConsulta
        ? `idAfiliado=${idAfiliado}&nroDocumento=${nroDocumento}&idObraSocial=${idObraSocial}&tipoConsulta=${tipoConsulta}`
        : `idAfiliado=${idAfiliado}&nroDocumento=${nroDocumento}&idObraSocial=${idObraSocial}`;
      const response = await fetchConToken(
        `Agenda/traerPorAfiliado?${parametros}`
      );
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        const lista = await response.json();
        if (response.status !== 200) throw lista.errores;
        dispatch(agendaLimpiarItems());
        dispatch(agendaTurnosSuccess(lista));
      }
      dispatch(finishSpinner());
    } catch (err) {
      dispatch(finishSpinner());
      dispatch(startAlerta(err, "warning", `¡Error!`));
    }
  };
};

export const fetchTurnosPorAfiliadoConFecha = (idAfiliado, fecha, onChange) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      dispatch(agendaTraerStart());
      const parametros = `idAfiliado=${idAfiliado}&fecha=${fecha}`;
      const response = await fetchConToken(`Agenda/traerPorAfiliadoConFecha?${parametros}`);
      const body = await response.json();
      if (response.ok){ 
        dispatch(agendaLimpiarItems());
        dispatch(agendaTurnosSuccess(body));
        dispatch(finishSpinner());
        onChange(body);
      } else {
          throw body
      }
    } catch (err) {
      dispatch(finishSpinner());
      dispatch(startAlerta(err, "warning", `¡Error!`));
    }
  };
};

export const fetchTurnosCanceladosPorAfiliado = (idAfiliado, nroDocumento, idObraSocial) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      dispatch(agendaTraerStart());
      const response = await fetchConToken(
        `Agenda/traerCanceladosPorAfiliado/${idAfiliado}/${nroDocumento}/${idObraSocial}`
      );
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        const lista = await response.json();
        if (response.status !== 200) throw lista.errores;
        dispatch(agendaTurnosSuccess(lista));
      }
      dispatch(finishSpinner());
    } catch (err) {
      dispatch(finishSpinner());
      dispatch(startAlerta(err, "warning", `¡Error!`));
    }
  };
};

export const fetchContadoresAfiliado = (idAfiliado, nroDocumento, idObraSocial) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      dispatch(agendaTraerStart());
      const response = await fetchConToken(
        `Agenda/traerContadoresPorAfiliado/${idAfiliado}/${nroDocumento}/${idObraSocial}`
      );
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        const contadores = await response.json();
        if (response.status !== 200) throw contadores.errores;
        dispatch(agendaContadoresSuccess(contadores));
      }
      dispatch(finishSpinner());
    } catch (err) {
      dispatch(finishSpinner());
      dispatch(startAlerta(err, "warning", `¡Error!`));
    }
  };
};
export const fetchTurnosTomadosPorFecha = (selectedDate, idProfesional) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      dispatch(agendaLimpiar());
      dispatch(agendaTraerStart());
      const parametros = armarParametros(
        null,
        null,
        idProfesional,
        null,
        null,
        selectedDate
      );
      const response = await fetchConToken(
        `Agenda/traerPorFecha?${parametros}`
      );
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        const lista = await response.json();
        if (response.status !== 200) throw lista.errores;
        dispatch(agendaLimpiar());
        dispatch(agendaTurnosSuccess(lista));
      }
      dispatch(finishSpinner());
    } catch (err) {
      dispatch(finishSpinner());
      dispatch(startAlerta(err, "warning", `¡Error!`));
    }
  };
};

export const fetchTurnosTomadosHastaFecha = (maxDate, idProfesional) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      dispatch(agendaTraerStart());
      const parametros = armarParametros(
        null,
        null,
        idProfesional,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        maxDate
      );
      const response = await fetchConToken(
        `Agenda/traerPorProfesional?${parametros}`
      );
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        const lista = await response.json();
        if (response.status !== 200) throw lista.errores;
        dispatch(agendaTurnosSuccess(lista));
      }
      dispatch(finishSpinner());
    } catch (err) {
      dispatch(finishSpinner());
      dispatch(startAlerta(err, "warning", `¡Error!`));
    }
  };
};

export const cancelarTurno = (idAgenda, idMotivoCancelacion) => {
  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner());
      dispatch(agendaTraerStart());
      const response = await fetchConToken(
        `Agenda/cancelarTurno`,
        { idAgenda, idMotivoCancelacion },
        "PUT"
      );
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        const lista = await response.json();
        if (response.status !== 200) throw lista.errores;
        dispatch(agendaCancelarTurnoSuccess(idAgenda));
        dispatch(
          startAlerta(
            `El turno ha sido cancelado de manera exitosa`,
            "success",
            "Cancelación exitosa"
          )
        );
        const contadores = getState().agenda.contadores;
        if (contadores) {
          contadores.cancelados++;
          contadores.tomados--;
          dispatch(agendaContadoresSuccess(contadores));
        }
      }
      dispatch(finishSpinner());
    } catch (err) {
      dispatch(finishSpinner());
      dispatch(startAlerta(err, "warning", `¡Error!`));
    }
  };
};

export const confirmarTurno = (
  idAgenda,
  idAfiliado,
  idTipoTurno,
  carnet,
  callback,
  idAfiliadoExterno = 0
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      dispatch(agendaTraerStart());
      const response = await fetchConToken(
        `Agenda/confirmarTurno`,
        { idAgenda, idAfiliado, idTipoTurno, carnet, idAfiliadoExterno },
        "PUT"
      );
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        const lista = await response.json();
        if (response.status !== 200) throw lista.errores;
        dispatch(
          startAlerta(
            `El turno ha sido generado de manera exitosa`,
            "success",
            "Generación exitosa"
          )
        );
        callback && callback(true);
      }
      dispatch(finishSpinner());
    } catch (err) {
      dispatch(finishSpinner());
      dispatch(startAlerta(err, "warning", `¡Error!`));
    }
  };
};

export const confirmarAsistenciaTurno = (
  idAgenda,
  confirmado,
  realizoPago = false,
  closeModalDemandaLaboratorio = null,
  fecha,
  idProfesional
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      dispatch(agendaTraerStart());
      const response = await fetchConToken(
        `Agenda/confirmarAsistenciaTurno`,
        { idAgenda, confirmado },
        "PUT"
      );
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        const lista = await response.json();
        if (response.status !== 200) throw lista.errores;
        let mensajePagoConfirmado = "";
        if (realizoPago) {
          mensajePagoConfirmado = "Su pago se ha realizado de manera exitosa. ";
        }
        dispatch(
          startAlerta(
            mensajePagoConfirmado +
              `La asistencia al turno ha sido ${
                confirmado ? "confirmada" : "cancelada"
              } de manera exitosa`,
            "success",
            `${
              confirmado ? "Confirmación" : "Cancelación"
            } de asistencia exitosa`
          )
        );
        if(closeModalDemandaLaboratorio){
          dispatch(
            fetchTurnosTomadosPorFecha(fecha.toISOString(), idProfesional)
          ); 
          closeModalDemandaLaboratorio();
        }
        dispatch(
          agendaTurnoModificarAsistenciaSuccess({ idAgenda, confirmado })
        );
      }
      dispatch(finishSpinner());
    } catch (err) {
      dispatch(finishSpinner());
      dispatch(startAlerta(err, "warning", `¡Error!`));
    }
  };
};

export const nuevoTurnoDemanda = (
  idEfHorario,
  idAfiliado,
  carnet,
  fecha,
  idProfesional,
  idObraSocial,
  nroDocumento,
  callback
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      dispatch(agendaTraerStart());
      const response = await fetchConToken(
        `Agenda/agregarTurnoPorDemanda`,
        { idEfHorario, idAfiliado, carnet, idObraSocial, nroDocumento },
        "POST"
      );
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        const lista = await response.json();
        if (response.status !== 200) throw lista.errores;
        dispatch(
          startAlerta(
            `El turno ha sido generado de manera exitosa`,
            "success",
            "Generación exitosa"
          )
        );
        dispatch(
          fetchTurnosTomadosPorFecha(fecha.toISOString(), idProfesional)
        );
        callback(true);
      }
      dispatch(finishSpinner());
    } catch (err) {
      dispatch(finishSpinner());
      dispatch(startAlerta(err, "warning", `¡Error!`));
    }
  };
};

export const nuevoSobreturno = (
  idEspecialidad,
  idCentroMedico,
  idProfesional,
  idAfiliado,
  carnet,
  dia,
  fecha,
  hora,
  idTipoTurno,
  callback,
  callback2,
  idAfiliadoExterno,
  openPracticas,
  closeQuestion,
  setTurno
) => {
  return async (dispatch) => {
    try {
      if (idAfiliadoExterno === undefined)
        idAfiliadoExterno = 0;      
      dispatch(startSpinner());
      dispatch(agendaTraerStart());
      const response = await fetchConToken(
        `Agenda/agregarSobreturno`,
        {
          idEspecialidad,
          idCentroMedico,
          idProfesional,
          idAfiliado,
          carnet,
          dia,
          fecha,
          idTipoTurno,
          hora,
          idAfiliadoExterno,
        },
        "POST"
      );
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        const body = await response.json();
        if (response.status !== 200) throw body.errores;
        dispatch(
          startAlerta(
            `El turno ha sido generado de manera exitosa`,
            "success",
            "Generación exitosa"
          )
        );
        if(idTipoTurno === TIPO_TURNO.VIRTUAL || !openPracticas){
          callback && callback(true);
          callback2 && callback2();
        }else{
          setTurno&& setTurno(body);
          closeQuestion&& closeQuestion();
          openPracticas&& openPracticas();
        }
      }
      dispatch(finishSpinner());
    } catch (err) {
      dispatch(finishSpinner());
      dispatch(startAlerta(err, "warning", `¡Error!`));
    }
  };
};

export const fetchTurnosPorParametrizacion = (
  idEfHorario,
  fechaDesde,
  fechaHasta,
  idCentroMedico,
  idProfesional,
  idEspecialidad
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      dispatch(agendaTraerStart());
      const response = await fetchConToken(
        `Agenda/traerPorParametrizacion?idEfHorario=${
          idEfHorario ? idEfHorario : 0
        }&fechaDesde=${fechaDesde}&fechaHasta=${fechaHasta}&idCentroMedico=${idCentroMedico}&idProfesional=${idProfesional}&idEspecialidad=${idEspecialidad}`
      );
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        const lista = await response.json();
        if (response.status !== 200) throw lista.errores;
        dispatch(agendaTurnosSuccess(lista));
      }
      dispatch(finishSpinner());
    } catch (err) {
      dispatch(finishSpinner());
      dispatch(startAlerta(err, "warning", `¡Error!`));
    }
  };
};

export const fetchPagoTurno = (
  idAgenda,
  setTurnoSelec,
  turno,
  cargarPracticas,
  confirmarTurnoAbonado
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const response = await fetchConToken(`Agenda/traerEstadoTurno/${idAgenda}`);
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        const estadoTurno = await response.json();
        if (response.status !== 200) throw estadoTurno.errores;
        if (!estadoTurno.adeudaTurno || estadoTurno.exento){
          setTurnoSelec({...turno, previamenteAbonado: true})
          confirmarTurnoAbonado&& confirmarTurnoAbonado();
        }
        else if (estadoTurno.adeudaTurno){                //if (estadoTurno.sinPracticas){
          cargarPracticas&& cargarPracticas();
        }
      }
      dispatch(finishSpinner());
    } catch (err) {
      dispatch(finishSpinner());
      dispatch(startAlerta(err, "warning", `¡Error!`));
    }
  };
};

export const fetchTurnosCanceladosEliminados = (
  fechaDesde,
  fechaHasta,
  idCentroMedico,
  idProfesional,
  idEspecialidad
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      dispatch(agendaTraerStart());
      const parametros = armarParametros(
        idEspecialidad,
        idCentroMedico,
        idProfesional,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        fechaHasta,
        null,
        fechaDesde
      );
      const response = await fetchConToken(
        `Agenda/traerCanceladosEliminados?${parametros}`
      );
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        const lista = await response.json();
        if (response.status !== 200) throw lista.errores;
        dispatch(agendaTurnosSuccess(lista));
      }
      dispatch(finishSpinner());
    } catch (err) {
      dispatch(finishSpinner());
      dispatch(startAlerta(err, "warning", `¡Error!`));
    }
  };
};

export const confirmarBajaTurnos = (idsAgenda, IdMotivoBaja) => {
  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner());
      dispatch(agendaTraerStart());
      const response = await fetchConToken(
        `Agenda/confirmarBajaTurnos`,
        { idsAgenda, IdMotivoBaja },
        "PUT"
      );
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        const lista = await response.json();
        if (response.status !== 200) throw lista.errores;
        const itemsAgenda = getState().agenda.items;
        const listaFiltrada = itemsAgenda.filter(function (e) {
          return this.indexOf(e.idAgenda) < 0;
        }, idsAgenda);
        dispatch(agendaTurnosSuccess(listaFiltrada));
        const contadores = getState().agenda.contadores;
        if (contadores) {
          contadores.cancelados++;
          contadores.tomados--;
          dispatch(agendaContadoresSuccess(contadores));
        }
      }
      dispatch(finishSpinner());
    } catch (err) {
      dispatch(finishSpinner());
      dispatch(startAlerta(err, "warning", `¡Error!`));
    }
  };
};

export const generatePdfRecepDiaria = (
  fecha,
  idProfesional,
  filtros = null
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const parametros = armarParametros(
        null,
        null,
        idProfesional,
        null,
        null,
        fecha,
        null,
        null,
        null,
        null,
        null,
        encodeURIComponent(JSON.stringify(filtros)) ? filtros : null
      );
      const response = await fetchConToken(
        `Agenda/generatePdfRecepDiaria?${parametros}`
      );
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/pdf") !== -1) {
        const blob = await response.blob();
        if (response.status !== 200) throw blob.errores;

        window.open(URL.createObjectURL(blob));
      }
      dispatch(finishSpinner());
    } catch (err) {
      console.log(err);
      dispatch(finishSpinner());
      dispatch(
        startAlerta(
          "Ocurrio un error en la generación del PDF",
          "warning",
          `¡Error!`
        )
      );
    }
  };
};

export const exportExcelRecepDiaria = (
  fecha,
  idProfesional,
  fechaArchivo,
  filtros = null
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const parametros = armarParametros(
        null,
        null,
        idProfesional,
        null,
        null,
        fecha,
        null,
        null,
        null,
        null,
        null,
        encodeURIComponent(JSON.stringify(filtros)) ? filtros : null
      );
      const response = await fetchConToken(
        `Agenda/exportExcelRecepDiaria?${parametros}`
      );
      const contentType = response.headers.get("content-type");
      if (
        contentType &&
        contentType.indexOf("officedocument.spreadsheetml") !== -1
      ) {
        const blob = await response.blob();
        if (response.status !== 200) throw blob.errores;

        let url = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        a.download = `RecepcionDiaria${fechaArchivo}.xlsx`;
        a.click();
      }
      dispatch(finishSpinner());
    } catch (err) {
      console.log(err);
      dispatch(finishSpinner());
      dispatch(
        startAlerta(
          "Ocurrio un error en la generación del Excel",
          "warning",
          `¡Error!`
        )
      );
    }
  };
};

export const generatePdfPorProfesional = (
  maxDate,
  idProfesional,
  filtros = null
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const parametros = armarParametros(
        null,
        null,
        idProfesional,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        encodeURIComponent(JSON.stringify(filtros)) ? filtros : null,
        maxDate
      );
      const response = await fetchConToken(
        `Agenda/generatePdfPorProfesional?${parametros}`
      );
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/pdf") !== -1) {
        const blob = await response.blob();
        if (response.status !== 200) throw blob.errores;

        window.open(URL.createObjectURL(blob));
      }
      dispatch(finishSpinner());
    } catch (err) {
      console.log(err);
      dispatch(finishSpinner());
      dispatch(
        startAlerta(
          "Ocurrio un error en la generación del PDF",
          "warning",
          `¡Error!`
        )
      );
    }
  };
};

export const exportExcelPorProfesional = (
  maxDate,
  idProfesional,
  fechaArchivo,
  filtros = null
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const parametros = armarParametros(
        null,
        null,
        idProfesional,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        encodeURIComponent(JSON.stringify(filtros)) ? filtros : null,
        maxDate
      );
      const response = await fetchConToken(
        `Agenda/exportExcelPorProfesional?${parametros}`
      );
      const contentType = response.headers.get("content-type");
      if (
        contentType &&
        contentType.indexOf("officedocument.spreadsheetml") !== -1
      ) {
        const blob = await response.blob();
        if (response.status !== 200) throw blob.errores;

        let url = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        a.download = `TurnosPorProfesional${fechaArchivo}.xlsx`;
        a.click();
      }
      dispatch(finishSpinner());
    } catch (err) {
      console.log(err);
      dispatch(finishSpinner());
      dispatch(
        startAlerta(
          "Ocurrio un error en la generación del Excel",
          "warning",
          `¡Error!`
        )
      );
    }
  };
};

export const getPracticasPorAgenda = (idAgenda) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const response = await fetchConToken(
        `TurnoPractica/traerPorTurno/${idAgenda}`
      );
      const body = await response.json();
      if (!response.ok) {
        throw body;
      }
      dispatch({ type: types.agendaGetPracticasSuccess, payload: body });
    } catch (error) {
      handleErrorApi(
        dispatch,
        error,
        "Error al traer practicas.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
    dispatch(finishSpinner());
  };
};

export const deletePracticasPorAgenda = (data) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const response = await fetchConToken(
        `TurnoPractica`,
        data,
        "DELETE"
      );
      const body = await response.json();
      if (!response.ok) {
        throw body;
      }
      if (data?.idAgenda) dispatch(getPracticasPorAgenda(data?.idAgenda));
    } catch (error) {
      handleErrorApi(
        dispatch,
        error,
        "Error al eliminar practica.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
    dispatch(finishSpinner());
  };
};

//AUTOPERCEPCION AFILIADO
export const getAutopercepcionPorAfiliado = (idAfiliado) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const response = await fetchConToken(
        `AutopercepcionAfiliado/${idAfiliado}`
      );
      if(response.ok && response.status === 204){     // No-Content
        dispatch({ type: types.agendaAutopercepcionAfiliadoGetSuccess, payload: null });
      }else{
        const body = await response.json();
        if (!response.ok) {
          throw body;
        }
        dispatch({ type: types.agendaAutopercepcionAfiliadoGetSuccess, payload: body });
      }   
    } catch (error) {
      dispatch({ type: types.agendaAutopercepcionAfiliadoGetError });
      handleErrorApi(
        dispatch,
        error,
        "Error al traer autopercepción.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
    dispatch(finishSpinner());
  };
};

export const saveAutopercepcionPorAfiliado = (idAfiliado, apeNom) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const response = await fetchConToken(
        `AutopercepcionAfiliado/${idAfiliado}`,
        { apeNom },
        'POST'
      );
      const body = await response.json();
      if (!response.ok) {
        throw body;
      }
      dispatch({ type: types.agendaAutopercepcionAfiliadoGetSuccess, payload: body });
      dispatch( 
        startAlerta(
          "El dato se grabo correctamente",
          "success",
          "Comando Exitoso"
        )
      );
    } catch (error) {
      dispatch({ type: types.agendaAutopercepcionAfiliadoGetError });
      handleErrorApi(
        dispatch,
        error,
        "Error al grabar autopercepción.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
    dispatch(finishSpinner());
  };
};

export const confirmAtencionPisoConsultorioTest = (idAgenda, piso, consultorio, closeModal) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const response = await fetchConToken(
        `Agenda/marcarTurnoAtendido`,
        { idAgenda, piso, consultorio },
        'PUT'
      );
      const body = await response.json();
      if (!response.ok) {
        throw body;
      }
      closeModal&& closeModal();
      dispatch({ type: types.agendaSetPisoConsultorioTest, payload: {idAgenda, piso, consultorio} });
    } catch (error) {
      handleErrorApi(
        dispatch,
        error,
        "Error al Setear piso y consultorio.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
    dispatch(finishSpinner());
  };
};

export const getPracticasPorAgendaExternos = (idAgenda, idObraSocial) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const response = await fetchConToken(
        `TurnoPractica/traerPorTurnoExterno/${idAgenda}/${idObraSocial}`
      );
      const body = await response.json();
      if (!response.ok) {
        throw body;
      }
      dispatch({ type: types.agendaGetPracticasSuccess, payload: body });
    } catch (error) {
      handleErrorApi(
        dispatch,
        error,
        "Error al traer practicas.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
    dispatch(finishSpinner());
  };
};

export const consultaPacientesEnSala =
  (idEfector, fecha) => async (dispatch) => {
    let fechaModif = fecha instanceof Date ? moment(fecha).format() : '';
    try {
      
      const response = await fetchConToken(
        `Agenda/PacientesEnSala/${idEfector}/${fechaModif}`,
      );
      const body = await response.json();
      if (response.ok) {
        dispatch({
          type: types.agendaGetPacientesEnSalaSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
    } catch (error) {
      handleErrorApi(
        dispatch,
        error,
        'Error al cargar el listado de turnos.',
        'Ha ocurrido un error. Intente Nuevamente',
      );
    }
  };

  export const consultaPacientesEnEspera =
  (idEfector, fecha) => async (dispatch) => {
    let fechaModif = fecha instanceof Date ? moment(fecha).format() : '';
    try {
      
      const response = await fetchConToken(
        `Agenda/PacientesEnEspera/${idEfector}/${fechaModif}`,
      );
      const body = await response.json();
      if (response.ok) {
        dispatch({
          type: types.agendaGetPacientesEnEsperaSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
    } catch (error) {
      handleErrorApi(
        dispatch,
        error,
        'Error al cargar el listado de turnos.',
        'Ha ocurrido un error. Intente Nuevamente',
      );
    }
  };

  
export const generarEstudioMedicoRecepcion = (
  idAgenda,
) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      dispatch(agendaTraerStart());
      const response = await fetchConToken(
        `Agenda/generarEstudioMedico`,
        { idAgenda },
        "POST"
      );
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        const lista = await response.json();
        if (response.status !== 200) throw lista.errores;
        dispatch(
          startAlerta(
            `El estudio medico ha sido generado`,
            "success",
            "Generación exitosa"
          )
        );
      }
      dispatch(finishSpinner());
    } catch (err) {
      dispatch(finishSpinner());
      dispatch(startAlerta(err, "warning", `¡Error!`));
    }
  };
};